import styled from 'styled-components';
import { media } from '../../../css';

export const SpaceSmall = styled.div`
  margin-bottom: 24px;

  ${media.greaterThan('md')`
        margin-bottom: 32px;
    `};
`;

export const SpaceMedium = styled.div`
  margin-bottom: 32px;

  ${media.greaterThan('md')`
        margin-bottom: 44px;
    `};
`;

export const SpaceLarge = styled.div`
  margin-bottom: 56px;

  ${media.greaterThan('md')`
        margin-bottom: 88px;
    `};
`;
